import { Controller } from '@hotwired/stimulus'

// Connects to data-controller='timestamp-localizer'
// -------------------------------------------------
// We currently do not store a member's timezone in the database so we can't format timestamps
// server-side during template rendering. To get around this, we can instead push this formatting
// down to the browser and use the member's browser's local timezone for displaying.
//
// Note that this Stimulus controller can be easily reused across the app. The only pre-req is that
// The ISO 8601 timestamp that we save in the database for any record (ActiveRecord default) is
// rendered as is within the element that we attach this Controller to so we can simply wrap the
// timestamp to format within an element with the correct data-controller attribute set:
//
// Example w/ localized date and timestamp:
//
//   <div data-controller="timestamp-localizer">
//     <%= @transaction.remote_created_at.iso8601 %> // raw ISO 8601 formatted DateTime
//   </div>
//
// Example w/ localized date (no timestamp):
//
//   <div data-controller="timestamp-localizer" data-timestamp-localizer-date-only-value="true">
//     <%= @transaction.remote_created_at.iso8601 %> // raw ISO 8601 formatted DateTime
//   </div>

export default class extends Controller<HTMLElement> {
  static values = {
    dateOnly: { type: Boolean, default: false },
  }

  declare dateOnlyValue: boolean

  connect () {
    const rawDate = this.element.dataset.iso8601 ?? this.element.innerHTML.trim()
    const utc = new Date(Date.parse(rawDate))
    let options: Intl.DateTimeFormatOptions
    let local

    if (this.dateOnlyValue) {
      // Show the localized date (example: November 11, 2023)
      options = { year: 'numeric', month: 'long', day: 'numeric' }
      local = utc.toLocaleDateString('en-us', options)
    } else {
      // Show the localized datetime (example: 11/11/2023 12:34 PM)
      options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' }
      local = utc.toLocaleTimeString('en-us', options)
    }

    this.element.innerHTML = local
  }
}
